<template>
    <div class="animated fadeIn">
        <b-row class="my-3">
            <b-col>
                <h4 class="text-center text-primary">
                    <i class="fa fa-comments text-primary mr-2"></i>
                    Listado de consultas
                </h4>
            </b-col>
        </b-row>

        <b-row class="pb-2">
            <b-card class="w-100">

                <b-row slot="header" class="m-0 p-0 justify-content-between align-items-center">
                    <div>Listado</div>
                    <div v-if="isAdvisory" class="d-flex flex-row justify-content-center align-items-center">
                        <div class="d-flex flex-column align-items-center mr-2">
                            <div>Mi Valoración</div>
                            <div>
                                <i v-for="n in Math.floor(rating.avg)" class="fa fa-star star-filled"></i>
                                <i v-for="n in (5 - Math.floor(rating.avg))" class="fa fa-star"></i>
                            </div>
                            <div>
                                <small>Sobre {{ rating.count }} Votos</small>
                            </div>
                        </div>
                        <div class="rate-box border rounded d-flex flex-column justify-content-center align-items-center">{{ rating.avg }}</div>
                    </div>
                    <div class="d-flex flex-column align-items-center">
                        <button
                            :disabled="count<1"
                            class="btn btn-primary btn-sm mb-2"
                            @click="exportQueries('csv')">
                            <i class="fa fa-download"></i> CSV
                        </button>
                        <button
                            :disabled="count<1"
                            class="btn btn-primary btn-sm"
                            @click="exportQueries('xlsx')">
                            <i class="fa fa-download"></i> Excel
                        </button>
                        <button
                                :disabled="count<1"
                                class="btn btn-primary btn-sm mt-2"
                                @click="exportQueries('pdf')">
                            <i class="fa fa-download"></i> PDF
                        </button>
                    </div>
                </b-row>

                <b-row class="mb-3">
                    <b-col md="10">
                        <b-row>

                            <b-col md="4">
                                <user-headquarters-selector v-model="search.headquarters"></user-headquarters-selector>
                            </b-col>

                            <b-col md="4">

                                <multiselect
                                    id="queryCategory"
                                    v-model="search.category"
                                    :options="queryCategories"
                                    track-by="uuid"
                                    :multiple="false"
                                    :allowEmpty="true"
                                    placeholder="Categoría"
                                    selectedLabel=""
                                    selectLabel=""
                                    deselectLabel="">
                                    <template slot="singleLabel" slot-scope="props">
                                        {{ props.option.name }}
                                    </template>
                                    <template slot="option" slot-scope="props">
                                        <template
                                            v-if="!!props.option.depth && props.option.depth>0"
                                            v-for="n in props.option.depth">-
                                        </template>
                                        {{ props.option.name }}
                                    </template>
                                </multiselect>

                            </b-col>

                            <b-col md="4">

                                <multiselect
                                    id="adviser"
                                    v-if="$_rolesMixin_checkRole(roles.queriesChief) || $_rolesMixin_checkRole(roles.queriesStaff) || search.all"
                                    v-model="search.adviser"
                                    :options="advisers"
                                    track-by="uuid"
                                    :customLabel="(adviser) => (`${adviser.firstname} ${adviser.lastname}`)"
                                    :multiple="false"
                                    :allowEmpty="true"
                                    placeholder="Asesor"
                                    selectedLabel=""
                                    selectLabel=""
                                    deselectLabel="">
                                </multiselect>

                            </b-col>
                        </b-row>

                        <b-row class="mt-2">

                            <b-col md="4">

                                <multiselect
                                    v-model="search.status"
                                    :options="queryStatesOptions"
                                    track-by="value"
                                    label="text"
                                    :multiple="false"
                                    :allowEmpty="true"
                                    placeholder="Estado"
                                    selectedLabel=""
                                    selectLabel=""
                                    deselectLabel="">
                                </multiselect>

                            </b-col>

                            <b-col md="4">

                                <b-form-input v-model="search.memberCode" placeholder="Código Socio"/>

                            </b-col>

                            <b-col md="4">

                                <vue2-date-picker
                                    v-model="search.dates"
                                    type="datetime"
                                    range
                                    :format="`DD/MM/YYYY`"
                                    :time-picker-options="datepicker.timeOptions"
                                    lang="es"
                                    placeholder="Rango de Fechas"
                                    :editable="false"
                                    :first-day-of-week="1"
                                    :shortcuts="datepicker.shortcuts"
                                    class="w-100 date-picker-w-100 date-picker-custom-border"></vue2-date-picker>

                            </b-col>
                        </b-row>
                        <b-row class="mt-2">
                            <b-col md="4">
                                <b-form-input v-model="search.number" placeholder="Número de consulta"/>
                            </b-col>
                            <b-col md="4">
                                <b-form-input v-model="search.clientPhone" placeholder="Tlf de contacto"/>
                            </b-col>
                            <b-col md="4">
                                <b-form-input v-model="search.description" placeholder="Descripción"/>
                            </b-col>
                        </b-row>
                        <b-row class="mt-2">
                          <b-col md="4">
                              <b-form-input v-model="search.email" placeholder="Email"/>
                          </b-col>
                          <b-col md="4">
                                <b-form-input v-model="search.nif" placeholder="NIF"/>
                          </b-col>
                          <b-col md="4">
                            <b-form-input v-model="search.memberName" placeholder="Nombre completo"/>
                          </b-col>
                        </b-row>
                        <b-row class="mt-2">
                          <b-col md="4">
                              <b-form-input v-model="search.province" placeholder="Provincia"/>
                          </b-col>
                          <b-col md="4">
                                <b-form-input v-model="search.town" placeholder="Ciudad"/>
                          </b-col>
                          <b-col md="4">
                            <b-form-input v-model="search.postalCode" placeholder="Código Postal"/>
                          </b-col>
                        </b-row>
                    </b-col>

                    <b-col md="2">
                        <div class="d-flex flex-row-reverse">
                            <button
                                class="btn btn-pill btn-primary px-4"
                                @click="searchQueries">
                                Filtrar
                            </button>
                        </div>

                        <b-row class="mt-2 pl-5" v-if="$_rolesMixin_checkRole(roles.advisoryChief)">
                            <b-col>
                                Ver todas
                                <toggle-button
                                    color="#025542"
                                    class="mt-1"
                                    :sync="true"
                                    v-model="search.all"
                                    :labels="{checked: 'Si', unchecked: 'No'}"/>
                            </b-col>
                        </b-row>
                    </b-col>

                </b-row>

                <v-server-table
                    ref="QueriesTable"
                    class="dataTable"
                    md="12"
                    lg="12"
                    sm="12"
                    :columns="columns"
                    :options="options"
                    :theme="theme"
                    @sorted="tableSorted">

                    <template slot="beforeBody">
                        <tr v-if="loading">
                            <td class="text-center loading" colspan="12"><spinner size="medium" line-fg-color="#025542" line-bg-color="#c8ced3"></spinner></td>
                        </tr>
                    </template>

                    <template slot="uuid" slot-scope="props">

                        <router-link
                            v-b-tooltip.hover.top
                            title="Ver"
                            :to="{ name: 'queryOverview', params: { uuid: props.row.uuid  }}">
                            <i class="fa fa-eye"></i>
                        </router-link>

                        <router-link
                            v-b-tooltip.hover.top
                            title="Reabrir"
                            class="ml-2"
                            v-if="['CLOSED'].includes(props.row.status) && props.row.children == false"
                            :to="{ name: 'addQuery', query: { status: 'REOPEN', originQueryId: props.row.uuid }}">
                            <i class="fa fa-repeat"></i>
                        </router-link>

                        <router-link
                            v-b-tooltip.hover.top
                            title="Reasignar"
                            class="ml-2"
                            v-if="['OPEN'].includes(props.row.status)"
                            :to="{ name: 'addQuery', query: { status: 'REASSIGNED', originQueryId: props.row.uuid }}">
                            <i class="fa fa-user-plus"></i>
                        </router-link>

                        <router-link
                            v-b-tooltip.hover.top
                            :title="'Ver consulta origen número ' + props.row.originQuery.number"
                            class="ml-2"
                            v-if="['REOPEN', 'REASSIGNED'].includes(props.row.status)"
                            :to="{ name: 'queryOverview', params: { uuid: props.row.originQuery.uuid  }}">
                            <i class="fa fa-arrow-left"></i>
                        </router-link>

                    </template>

                    <template slot="createdBy" slot-scope="props">
                        {{props.row.createdBy.name}}
                    </template>

                    <template slot="date" slot-scope="props">
                        {{props.row.date | dateFormat('DD/MM/YYYY HH:mm')}}
                    </template>

                    <template slot="category" slot-scope="props">
                        {{props.row.category.name}}
                    </template>

                    <template slot="client" slot-scope="props">
                        {{props.row.client.name}}
                    </template>

                    <template slot="adviser" slot-scope="props">
                        {{props.row.adviser.name}}
                    </template>

                    <template slot="potentialMember" slot-scope="props">
                        <template v-if="!!props.row.client && !!props.row.client.code">
                            {{props.row.client.code}}
                        </template>
                        <template v-else>
                            <template v-if="!!props.row.potentialMember">
                                Posible Socio
                            </template>
                            <template v-else>
                                Sin interés
                            </template>
                        </template>
                    </template>


                    <template slot="issuesCount" slot-scope="props">
                        <template v-if="props.row.issuesCount > 0">
                            Si
                        </template>
                        <template v-else>
                            No
                        </template>
                    </template>

                </v-server-table>

                <span class="badge normal-query ml-2">Consulta abierta</span>
                <span class="badge yellow-query ml-2">Consulta urgente</span>
                <span class="badge blue-query ml-2">Consulta reabierta</span>
                <span class="badge orange-query ml-2">Consulta reabierta urgente</span>
                <span class="badge red-query ml-2">Consulta reasignada</span>
                <span class="badge green-query ml-2">Consulta cerrada</span>
                <span class="badge black-query ml-2">Consulta cerrada sin resolver</span>

            </b-card>
        </b-row>

    </div>
</template>

<script>
    import Vue from 'vue';
    import form from '@/helpers/form';
    import {ServerTable, Event} from 'vue-tables-2';
    import Vue2DatePicker from 'vue2-datepicker';
    import Multiselect from 'vue-multiselect';
    import {downloadJsonAsCsv, downloadJsonAsXlsx} from '@/helpers/js-xlsx';
    import {downloadJsonAsPdf} from '@/helpers/js-pdf';
    import {getQueries} from '@/api/query-api';
    import {getQueryRatingStatistics} from '@/api/query-rating-api';
    import {getQueryCategoriesTree} from '@/api/query-category-api';
    import {getAdvisers} from '@/api/user-api';
    import {getQueryStatesOptions} from '@/helpers/query-helper';
    import {roles} from '@/constants/roles-constants';
    import userHeadquartersSelector from '@/components/headquarters/UserHeadquartersSelector';
    import Spinner from 'vue-simple-spinner';
    import moment from 'moment';

    Vue.use(ServerTable);

    export default {
        name: 'list-queries',
        components: {
            Multiselect,
            Vue2DatePicker,
            userHeadquartersSelector,
            Spinner
        },
        data: function () {
            return {
                roles,
                topmenu: [
                    {
                        name: 'Inicio',
                        path: '/admin/dashboard',
                        brand: 'fa fa-home'
                    },
                ],
                columns: ['uuid', 'number', 'createdBy', 'date', 'category', 'client', 'potentialMember', 'adviser', 'description', 'issuesCount'],
                loading: true,
                options: {
                    headings: {
                        uuid: {
                            text: '',
                            id: 'fit'
                        },
                        number: 'Número',
                        createdBy: 'Registrada por',
                        date: 'Fecha',
                        category: 'Categoría',
                        client: 'Cliente',
                        adviser: 'Asesor',
                        description: 'Consulta',
                        potentialMember: 'Socio',
                        issuesCount: 'Incidencias',
                    },
                    columnsClasses: {
                        uuid: "fit normal-query"
                    },
                    sortIcon: {
                        base: 'fa',
                        up: 'fa-sort-asc',
                        down: 'fa-sort-desc',
                        is: 'fa-sort'
                    },
                    sortable: ['number', 'createdBy', 'date', 'category', 'client', 'potentialMember', 'adviser', 'description', 'issuesCount'],
                    filterable: false,
                    texts: null,
                    pagination: {
                        chunk: 10,
                        edge: true,
                        nav: 'scroll'
                    },
                    rowClassCallback: (row) => this.getRowClassByStatus(row),
                    requestFunction: (data) => {
                        if (this.$store.getters.getFilters[0] !== null) {
                           this.search.headquarters = this.$store.getters.getFilters[0];
                        }
                        if (this.$store.getters.getFilters[1] !== null) {
                          this.search.category = this.$store.getters.getFilters[1];
                        }
                        if (this.$store.getters.getFilters[2] !== null) {
                          this.search.adviser = this.$store.getters.getFilters[2];
                        }
                        if (this.$store.getters.getFilters[3] !== null) {
                          this.search.status = this.$store.getters.getFilters[3];
                        }
                        if (this.$store.getters.getFilters[4] !== null) {
                          this.search.memberCode = this.$store.getters.getFilters[4];
                        }
                        if (this.$store.getters.getFilters[5] !== null) {
                          this.search.dates = this.$store.getters.getFilters[5];
                        }
                        if (this.$store.getters.getFilters[6] !== null) {
                          this.search.number = this.$store.getters.getFilters[6];
                        }
                        if (this.$store.getters.getFilters[7] !== null) {
                          this.search.clientPhone = this.$store.getters.getFilters[7];
                        }
                        if (this.$store.getters.getFilters[8] !== null) {
                          this.search.description = this.$store.getters.getFilters[8];
                        }
                        if (this.$store.getters.getFilters[9] !== null) {
                          this.search.email = this.$store.getters.getFilters[9];
                        }
                        if (this.$store.getters.getFilters[10] !== null) {
                          this.search.nif = this.$store.getters.getFilters[10];
                        }
                        if (this.$store.getters.getFilters[11] !== null) {
                          this.search.memberName = this.$store.getters.getFilters[11];
                        }
                        if (this.$store.getters.getFilters[12] !== null) {
                          this.search.province = this.$store.getters.getFilters[12];
                        }
                        if (this.$store.getters.getFilters[13] !== null) {
                          this.search.town = this.$store.getters.getFilters[13];
                        }
                        if (this.$store.getters.getFilters[14] !== null) {
                          this.search.postalCode = this.$store.getters.getFilters[14];
                        }
                        this.search.page = data.page;
                        this.search.itemsPerPage = data.limit;
                        return getQueries(this.searchData);
                    },
                    responseAdapter: (data) => {
                        return {
                            data: data.queries,
                            count: data.count
                        }
                    },
                },
                theme: 'bootstrap4',
                orderBy: {
                    column: null,
                    ascending: null
                },
                search: {
                    page: 1,
                    itemsPerPage: 10,
                    status: null,
                    category: null,
                    clientPhone: null,
                    email: null,
                    nif: null,
                    memberName: null,
                    headquarters: null,
                    adviser: null,
                    memberCode: null,
                    number: null,
                    dates: null,
                    province: null,
                    town: null,
                    postalCode: null,
                    all: false
                },
                count: 0,
                queryCategories: [],
                advisers: [],
                datepicker: {
                    shortcuts: [
                        {
                            text: 'Hoy',
                            onClick: () => {
                                let dateStart = new Date();
                                dateStart.setHours(0, 0, 0);
                                let dateEnd = new Date();
                                dateEnd.setHours(23, 59, 59);
                                this.search.dates = [dateStart, dateEnd]
                            }
                        },
                        {
                            text: 'Últimos 7 días',
                            onClick: () => {
                                let days = 7;
                                let today = new Date();
                                today.setHours(23, 59, 59);
                                let last = new Date(today.getTime() - (days * 24 * 60 * 60 * 1000));
                                last.setHours(0, 0, 0);
                                this.search.dates = [last, today]
                            }
                        },
                        {
                            text: 'Últimos 30 días',
                            onClick: () => {
                                let days = 30;
                                let today = new Date();
                                today.setHours(23, 59, 59);
                                let last = new Date(today.getTime() - (days * 24 * 60 * 60 * 1000));
                                last.setHours(0, 0, 0);
                                this.search.dates = [last, today]
                            }
                        }
                    ],
                    timeOptions: {
                        start: '00:00',
                        step: '01:00',
                        end: '23:00'
                    }
                },
                rating: {
                    avg: 0,
                    count: 0
                }
            }
        },
        computed: {
            queryStatesOptions() {
                return getQueryStatesOptions();
            },
            searchData() {
                let data = {
                    page: this.search.page,
                    itemsPerPage: this.search.itemsPerPage,
                };

                if (!!this.search.status) {
                    data['status'] = this.search.status.value;
                }
                if (!!this.search.category && !!this.search.category.uuid) {
                    data['categoryId'] = this.search.category.uuid;
                }
                if (!!this.search.number) {
                    data['queryNumber'] = this.search.number;
                }
                if (!!this.search.headquarters && !!this.search.headquarters.uuid) {
                    data['headquartersId'] = this.search.headquarters.uuid;
                }
                if (!!this.search.adviser && !!this.search.adviser.uuid) {
                    data['adviserId'] = this.search.adviser.uuid;
                }
                if (!!this.search.memberCode) {
                    data['memberCode'] = this.search.memberCode;
                }
                if (!!this.search.clientPhone) {
                    data['clientPhone'] = this.search.clientPhone;
                }
                if (!!this.search.description) {
                    data['description'] = this.search.description;
                }
                if (!!this.search.email) {
                    data['email'] = this.search.email;
                }
                if (!!this.search.nif) {
                    data['nif'] = this.search.nif;
                }
                if (!!this.search.memberName) {
                  data['memberName'] = this.search.memberName;
                }
                if (!!this.search.province) {
                    data['province'] = this.search.province;
                }
                if (!!this.search.town) {
                    data['town'] = this.search.town;
                }
                if (!!this.search.postalCode) {
                  data['postalCode'] = this.search.postalCode;
                }
                if (Array.isArray(this.search.dates)
                    && this.search.dates.length === 2
                    && this.search.dates[0] != null
                    && this.search.dates[1] != null) {
                    data['startDate'] = this.search.dates[0].toISOString();
                    data['endDate'] = this.search.dates[1].toISOString();
                }
                data["all"] = this.search.all ? 1 : 0;

                if (!!this.orderBy.column) {
                    data['orderColumn'] = this.orderBy.column;
                }
                data['orderAscending'] = this.orderBy.ascending ? 1 : 0;

                return data;
            },
            isAdvisory() {
                return this.$_rolesMixin_checkRoles([roles.advisoryChief, roles.advisoryStaff]);
            }
        },

        beforeMount() {
        },
        mounted() {
            this.options.texts = form.tableLabels();
            this.$eventHub.$emit('captureMenu', this.topmenu);

            // vue-tables events
            Event.$on('vue-tables.loading', (data) => {
                this.$_loadingMixin_showLoading();
                this.count = 0;
                this.loading = true;
                //this.$refs.QueriesTable.data = [];
                if (!!document.querySelector('.VueTables__no-results')) {
                    document.querySelector('.VueTables__no-results').style.display = 'none';
                }
                if (!!document.querySelector('.VueTables__row')) {
                    document.querySelector('.VueTables__row').style.display = 'none';
                }
            });
            Event.$on('vue-tables.loaded', (data) => {
                if (!!data && !!data.count) {
                    this.count = data.count;
                }
                this.$_loadingMixin_hideLoading();
                this.loading = false;
                if (!!document.querySelector('.VueTables__no-results')) {
                    document.querySelector('.VueTables__no-results').style.display = 'table-row';
                }
                if (!!document.querySelector('.VueTables__row')) {
                    document.querySelector('.VueTables__row').style.display = 'table-row';
                }
            });

            this.getQueryCategories();
            this.getAdvisers();
            if (this.isAdvisory) {
                this.getQueryRatingStatistics();
            }
        },
        methods: {
            getRowClassByStatus: function (row) {
                let classString = "query-row ";
                switch (row.status) {
                    case 'OPEN':
                        classString += row.urgent ? 'yellow-query' : 'normal-query';
                        break;
                    case 'CLOSED':
                        classString += 'black-query';
                        break;
                    case 'REOPEN':
                        classString += row.urgent ? 'orange-query' : 'blue-query';
                        break;
                    case 'REASSIGNED':
                        classString += 'red-query';
                        break;
                    case 'RESOLVED':
                        classString += 'green-query';
                        break;
                    default:
                        classString += 'normal-query';
                }
                return classString;
            },
            async getQueryCategories() {
                this.$_loadingMixin_showLoading();
                await getQueryCategoriesTree()
                    .then((queryCategories) => {
                        this.queryCategories = queryCategories;
                    });
                this.$_loadingMixin_hideLoading();
            },
            async getAdvisers() {
                this.$_loadingMixin_showLoading();
                await getAdvisers()
                    .then((advisers) => {
                        this.advisers = advisers;
                    });
                this.$_loadingMixin_hideLoading();
            },
            async getQueryRatingStatistics() {
                this.$_loadingMixin_showLoading();
                await getQueryRatingStatistics()
                    .then((statistics) => {
                        this.rating = statistics;
                    });
                this.$_loadingMixin_hideLoading();
            },
            searchQueries() {
                let filterData = [];
                filterData.push(this.search.headquarters);
                filterData.push(this.search.category);
                filterData.push(this.search.adviser);
                filterData.push(this.search.status);
                filterData.push(this.search.memberCode);
                filterData.push(this.search.dates);
                filterData.push(this.search.number);
                filterData.push(this.search.clientPhone);
                filterData.push(this.search.description);
                filterData.push(this.search.email);
                filterData.push(this.search.nif);
                filterData.push(this.search.memberName);
                filterData.push(this.search.province);
                filterData.push(this.search.town);
                filterData.push(this.search.postalCode);
                this.$store.commit('SET_FILTERS_LIST', filterData);
                this.$refs.QueriesTable.refresh();
            },
            async exportQueries(format) {
                if (this.count > 0) {
                    this.$_loadingMixin_showLoading();

                    // let parameters = Object.assign({}, this.searchData);
                    // parameters.page = 1;
                    // parameters.itemsPerPage = this.count;

                    // let response = await getQueries(parameters);
                    let response = await getQueries(this.searchData);

                    let rows = response.queries.map((query) => {
                        return this.normalizeQuery(query);
                    });

                    if (format === 'csv') {
                        downloadJsonAsCsv(rows);
                    } else if (format === 'xlsx') {
                        downloadJsonAsXlsx(rows);
                    } else if (format === 'pdf') {
                        rows = rows.map(row => {
                           delete row['Comentario'];
                           delete row['Consulta'];
                           return row;
                        });
                        downloadJsonAsPdf(rows);
                    }

                    this.$_loadingMixin_hideLoading();
                }
            },
            normalizeQuery(query) {
                return {
                    'ID': query.uuid,
                    'Número': query.number,
                    'Registrada por': query.createdBy.name,
                    'Fecha': new Date(query.date).toLocaleDateString(),
                    'Sede': query.headquarters.name,
                    'Categoría': query.category.name,
                    'Cliente': query.client.name,
                    'Origen': query.origin,
                    'Asesor': query.adviser.name,
                    'Consulta': query.description,
                    'Comentario': query.comment,
                    'Urgente': query.urgent,
                    'Potencial Socio': query.potentialMember,
                    'Incidencias': query.issuesCount > 0,
                };
            },
            tableSorted(data) {
                this.orderBy.column = data.column;
                this.orderBy.ascending = data.ascending;
            }
        }
    }
</script>

<style lang="scss">
    .yellow-query {
        background-color: #ffc107 !important;
        color: #23282c;
    }

    .blue-query {
        background-color: #63c2de !important;
        color: #23282c;
    }

    .orange-query {
        background-color: darkorange !important;
    }

    .red-query {
        background-color: #f86c6b !important;
        color: white;
    }

    .green-query {
        background-color: lightgreen !important;
    }

    .black-query {
        background-color: gray !important;
        color: white;
    }

    .normal-query {
        background-color: white !important;
    }

    .rate-box {
        font-weight: bold;
        font-size: 20px;
        text-align: center;
        background-color: yellow;
        width: 55px;
        height: 55px;
    }

    .fa.fa-star {
        color: white;
    }

    .fa.fa-star.star-filled {
        color: yellow;
    }

    .VueTables__no-results {
        display: none;
    }
</style>
